module.exports = __webpack_public_path__ + "img/setdark.6c88f531.svg";